import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Topbar.module.css';

const SearchIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootSearchIcon, className);

  return (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.26318 17.9473L1.91866 24.2918" fill="none" stroke="#2F0F48" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle fill="none" cx="9.07895" cy="9.07895" r="9.07895" transform="matrix(-1 0 0 1 24 1)" stroke="#2F0F48" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    
  );
};

const { string } = PropTypes;

SearchIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

SearchIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default SearchIcon;
